export default "__VITE_ASSET__BeaTsRfX__"